import React, { useState, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import axios from "axios";


export default function DashboardTable() {
  /* ================= STATES ================= */

  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;
  const [isLeadStagePickerOpen, setIsLeadStagePickerOpen] = useState(false);
  const [filterData, setFilterData] = useState("-1");
  const [userType, setUserType] = useState("1");
  const [dataType, setDataType] = useState("Booking");
  const [serviceTypeSummary, setServiceTypeSummary] = useState(null);


  // 👉 UI Text State
  const [dateRangeStage, setDateRangeStage] = useState("Select Date Range");
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });
  let startdate = formatDate(selectionRange.startDate);
  let enddate = formatDate(selectionRange.endDate);
  if (dateRangeStage === "Select Date Range") {
    startdate = "";
    enddate = "";
  }
  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }


  // 👉 Helper function to calculate row total
  const calculateRowTotal = (row) => {
    return columns.reduce((sum, col) => {
      const value = row[col];
      return sum + (typeof value === 'number' ? value : 0);
    }, 0);
  };


  /* ================= FUNCTIONS ================= */

  const handleSelectLeadStage = (ranges) => {
    const start = ranges.selection.startDate;
    const end = ranges.selection.endDate;

    setSelectionRange(ranges.selection);

    // 👉 Update Button Text
    setDateRangeStage(`${formatDate(start)} - ${formatDate(end)}`);
  };

  const toggleLeadStagePicker = () => {
    setIsLeadStagePickerOpen(!isLeadStagePickerOpen);
  };

  const closeFilterLeadStage = () => {
    setDateRangeStage("Select Date Range");
    setIsLeadStagePickerOpen(false);
  };

  const handleFilterChange = (e) => {
    setFilterData(e.target.value);
  };

  const handleUserTypeChange = (e) => {
    setUserType(e.target.value);
  };

  const handleDataTypeChange = (e) => {
    setDataType(e.target.value);
  };

  const leadStageApplyButton = () => {
    fetchSummary();
    setIsLeadStagePickerOpen(false);
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetServiceTypeSummary?startDate=${startdate}&endDate=${enddate}&DateType=${dataType}&status=${filterData}&userType=${userType}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          const data = response.data.data;
          if (response.data.status === "True" && data.length > 0) {
            setTableData(data);
            // Extract dynamic columns
            const firstRow = data[0];
            const cols = Object.keys(firstRow).filter(
              (key) => key !== "Coordinator"
            );
            setColumns(cols);
          }
        }).catch((error) => {
          console.error("There was an error fetching the data!", error);
        });
    } else {
      console.error("No token found in localStorage");
    };

    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetServiceTypeSummaryCount?startDate=${startdate}&endDate=${enddate}&DateType=${dataType}&status=${filterData}&userType=${userType}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          const data = response.data.data;
          if (response.data.status === "True" && data.length > 0) {
            setServiceTypeSummary(data[0]);
          }
        }).catch((error) => {
          console.error("There was an error fetching the data!", error);
        });
    } else {
      console.error("No token found in localStorage");
    };
  };


  /* ================= UI ================= */

  return (
    <>
      <div className="dashboard-container">
        {/* HEADER */}
        <div className="dashboard-header">
          <div className="innerFilterLead1">
            <div className="filter-icon-stage1">
              <img
                src={require("../../../Icons/filterIcon.png")}
                alt="filter"
              />
              <b>FILTER</b>
            </div>

            {/* DATE PICKER */}
            <div className="date-wrapper">
              <button onClick={toggleLeadStagePicker} className="date-btn">
                <b className="select_dateRange">{dateRangeStage}</b>
              </button>

              {isLeadStagePickerOpen && (
                <div className="picker-popup">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={handleSelectLeadStage}
                  />

                  <div className="picker-actions">
                    <button
                      onClick={leadStageApplyButton}
                      className="apply-filter-btn"
                    >
                      Apply Filter
                    </button>

                    <button
                      onClick={closeFilterLeadStage}
                      className="close-filter-btn"
                    >
                      Clear
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* DROPDOWN */}
            <select
              value={filterData}
              onChange={handleFilterChange}
              className="dropdown"
            >
              <option value="-2" disabled >Status</option>
              <option value="-1">All</option>
              <option value="0">Untouched</option>
              <option value="1">Open</option>
              <option value="2">Executed</option>
              <option value="3">Cancelled</option>
              <option value="4">Abandoned</option>
            </select>

            <select
              value={userType}
              onChange={handleUserTypeChange}
              className="dropdown"
            >
              <option value="-1">All Users</option>
              <option value="0">Inactive User</option>
              <option value="1">Active User</option>
            </select>

            <select
              value={dataType}
              onChange={handleDataTypeChange}
              className="dropdown"
            >
              <option value="Booking">Booking</option>
              <option value="Execution">Execution</option>

            </select>
            {/* APPLY BUTTON */}
            <button onClick={leadStageApplyButton} className="apply-main-btn">
              Apply
            </button>
          </div>
          
          <div className="filters-right">
            {dataType}: {" "}
            <b className="" style={{ fontSize: "12" }}>{serviceTypeSummary?.TotalCount || "No Data"}</b>
          </div>
        </div>

        {/* TABLE */}
        <div className="table-wrapper" style={{maxHeight: "504px"}}>
          <table className="dashboard-table">
            <thead className="table-weapper-thead">
              <tr>
                <th>Users</th>
                {columns.map((col, index) => (
                  <th key={index}>{col}</th>
                ))}
                <th className="total-column">Total</th>
              </tr>
            </thead>

            <tbody>
              {tableData.map((row, i) => (
                <tr
                  key={i}
                  className={row.Coordinator === "Grand Total" ? "grand-total" : ""}
                >
                  <td className="user-cell" style={{fontSize: "13px", fontWeight: "600"}}>{row.Coordinator}</td>

                  {columns.map((col, index) => (
                    <td key={index} className="data-cell">
                      {row[col] ?? 0}
                    </td>
                  ))}

                  <td className="total-cell">
                    {calculateRowTotal(row)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ================= CSS ================= */}

      <style jsx>{`
      .table-weapper-thead{
      position: sticky;
    top: 0;
    padding: 10px 16px;
    background: #555;
    color: #f1f1f1;
      }
      .filters-right{
    padding: 11px 4px 9px 15px;
    border: 1px solid #5b489d;
    background: transparent;
    margin-top: 12px;
    height: 47px;
    width: 8rem;
    color: black;
    border-radius: 6px;
    margin-right: 8px;
    // cursor: pointer;
      }
      .user-cell, .data-cell{
      border: 1px solid #c0c6cc
      }
     .filter-icon-stage1 {
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.25);
    width: 87px;
    height: 104%;
    position: relative;
    padding: 9px;
    padding-top: 16px;
    background-color: white;
    border-radius: 9px;
    top: -5px;
    left: -22px;
    font-size: 12px;
}
        .innerFilterLead1 {
          display: flex;
          border: 1px solid #c0c6cc;
          border-radius: 16px;
          margin-top: 11px;
          /* margin-left: -49px; */
          padding: 7px 8px 0px 13px;
          height: 55px;
          gap: 14px;
        }
        .select_dateRange {
          font-size: 11px;
        }
        .dashboard-container {
          padding: 20px;
          background: #fff;
          font-family: Arial;
           border-radius: 20px;
        }

        .dashboard-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          flex-wrap: wrap;
        }

        .innerFilterLead {
          display: flex;
          gap: 10px;
          align-items: center;
        }

        .date-wrapper {
          position: relative;
        }

        .date-btn {
          width: 9rem;
          height: 2.5rem;
          border-radius: 8px;
          border: 1px solid #ccc;
          background: white;
          cursor: pointer;
        }

        .picker-popup {
          position: absolute;
          z-index: 999;
          border: 1px solid black;
          margin-top: 5px;
          background: white;
        }

        .picker-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          padding: 10px;
        }

        .apply-filter-btn {
          background: #5b489d;
          color: white;
          border: none;
          padding: 8px 15px;
          border-radius: 6px;
          cursor: pointer;
        }

        .close-filter-btn {
          color: red;
          background: white;
          border: none;
          font-weight: bold;
          cursor: pointer;
        }

        .dropdown {
          width: 6rem;
          height: 2.5rem;
          border-radius: 6px;
          font-size: 14px;
        }

        .apply-main-btn {
          background: #5b489d;
          color: white;
          border: none;
          height: 2.5rem;
          width: 5rem;
          border-radius: 6px;
          cursor: pointer;
        }

        .outline-btn {
          border: 1px solid #5b489d;
          background: transparent;
          margin-top: 12px;
          height: 3rem;
          color: black;
          padding: 8px 14px;
          border-radius: 6px;
          margin-right: 8px;
          cursor: pointer;
        }

        .table-wrapper {
          background: white;
          border-radius: 8px;
          overflow-x: auto;
        }

        .dashboard-table {
          width: 100%;
          border-collapse: collapse;
        }

        .dashboard-table th {
          background: #e5e5e5;
          padding: 12px;
        }

        .dashboard-table td {
          padding: 12px;
          border-top: 1px solid #eee;
        }

        .user-cell {
          text-align: left;
          font-weight: 500;
        }

        .data-cell {
          background: #f3efff;
        }

        .total-column {
          background: #d4c5f9;
          font-weight: bold;
        }

        .total-cell {
          background: #d4c5f9;
          font-weight: bold;
          text-align: center;
        }

        .grand-total {
          background: #e5e5e5;
          font-weight: bold;
        }

        .grand-total .total-cell {
          background: #c5c5c5;
        }
      `}</style>
    </>
  );
}